import isString from 'lodash/isString';
import { exception } from '@/exceptions/Exceptions';
import Countries from '@/resources/countryUtils.json';

export const formatPostcode = (postcode) => {
    const postcodeRegExDE = /^[0-9]{5}$/i;
    const postcodeRegExUK = /(^[A-Z]{1,2}[0-9]{1,2}[A-Z]{0,1})([0-9][A-Z]{2}$)/i;

    if (!isPostcodeFormatValid(postcode)) exception('Invalid Postcode.');
    else if (postcodeRegExDE.test(postcode)) {
        return postcode;
    }
    return postcode.replace(postcodeRegExUK, '$1 $2').toUpperCase();
};

export const isPostcodeFormatValid = (postcode) => {
    if (!postcode || !isString(postcode)) return false;

    const country = Countries.find((item) => item.postcode_locale === process.env.VUE_APP_POSTCODER_LOCALE);
    const regex = new RegExp(country.postcode_regex, 'i');
    return regex.test(postcode);
};
